import { NgModule } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'groupByLevel' })
export class GroupByLevelPipe implements PipeTransform {
    transform(collection: any, properties: Array<any>): any {
        // prevents the application from breaking if the array of objects doesn't exist yet
        if (!collection) {
            return null;
        }  
        

        const groupedCollection = collection.reduce((previous, current) => {
            let key = '';
             properties.forEach((item) => { key = key + current[item] });
            if (!previous[key]) {
                previous[key] = [current];
            } else {
                previous[key].push(current);
            }

            return previous;
        }, {});

        // this will return an array of objects, each object containing a group of objects
        const data = Object.keys(groupedCollection).map(key => ({ key, value: groupedCollection[key] }));
        return data;
    }
}

@NgModule({
    declarations: [GroupByLevelPipe],
    exports: [GroupByLevelPipe]
})
export class GroupByLevelModule { }



// WEBPACK FOOTER //
// ./src/app/customerservice/models/group-by-level/group-by-level.module.ts